/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PanelRouteImport } from './routes/_panel'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PanelIndexRouteImport } from './routes/_panel.index'
import { Route as PanelExpertsRouteImport } from './routes/_panel.experts'
import { Route as PanelReportingRouteImport } from './routes/_panel.reporting'
import { Route as PanelAttachmentsAttachmentIdRouteImport } from './routes/_panel.attachments.$attachmentId'
import { Route as PanelQueriesQueryIdRouteImport } from './routes/_panel.queries.$queryId'
import { Route as PanelVettingRequestsVettingIdRouteImport } from './routes/_panel.vetting-requests.$vettingId'
import { Route as PanelVettingIndexRouteImport } from './routes/_panel.vetting.index'
import { Route as PanelVettingVettingIdRouteImport } from './routes/_panel.vetting.$vettingId'

const PanelRoute = PanelRouteImport.update({
  id: '/_panel',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PanelIndexRoute = PanelIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PanelRoute,
} as any)
const PanelExpertsRoute = PanelExpertsRouteImport.update({
  id: '/experts',
  path: '/experts',
  getParentRoute: () => PanelRoute,
} as any)
const PanelReportingRoute = PanelReportingRouteImport.update({
  id: '/reporting',
  path: '/reporting',
  getParentRoute: () => PanelRoute,
} as any)
const PanelAttachmentsAttachmentIdRoute =
  PanelAttachmentsAttachmentIdRouteImport.update({
    id: '/attachments/$attachmentId',
    path: '/attachments/$attachmentId',
    getParentRoute: () => PanelRoute,
  } as any)
const PanelQueriesQueryIdRoute = PanelQueriesQueryIdRouteImport.update({
  id: '/queries/$queryId',
  path: '/queries/$queryId',
  getParentRoute: () => PanelRoute,
} as any)
const PanelVettingRequestsVettingIdRoute =
  PanelVettingRequestsVettingIdRouteImport.update({
    id: '/vetting-requests/$vettingId',
    path: '/vetting-requests/$vettingId',
    getParentRoute: () => PanelRoute,
  } as any)
const PanelVettingIndexRoute = PanelVettingIndexRouteImport.update({
  id: '/vetting/',
  path: '/vetting/',
  getParentRoute: () => PanelRoute,
} as any)
const PanelVettingVettingIdRoute = PanelVettingVettingIdRouteImport.update({
  id: '/vetting/$vettingId',
  path: '/vetting/$vettingId',
  getParentRoute: () => PanelRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof PanelIndexRoute
  '/login': typeof LoginRoute
  '/experts': typeof PanelExpertsRoute
  '/reporting': typeof PanelReportingRoute
  '/attachments/$attachmentId': typeof PanelAttachmentsAttachmentIdRoute
  '/queries/$queryId': typeof PanelQueriesQueryIdRoute
  '/vetting-requests/$vettingId': typeof PanelVettingRequestsVettingIdRoute
  '/vetting/$vettingId': typeof PanelVettingVettingIdRoute
  '/vetting/': typeof PanelVettingIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/experts': typeof PanelExpertsRoute
  '/reporting': typeof PanelReportingRoute
  '/': typeof PanelIndexRoute
  '/attachments/$attachmentId': typeof PanelAttachmentsAttachmentIdRoute
  '/queries/$queryId': typeof PanelQueriesQueryIdRoute
  '/vetting-requests/$vettingId': typeof PanelVettingRequestsVettingIdRoute
  '/vetting/$vettingId': typeof PanelVettingVettingIdRoute
  '/vetting': typeof PanelVettingIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_panel': typeof PanelRouteWithChildren
  '/login': typeof LoginRoute
  '/_panel/experts': typeof PanelExpertsRoute
  '/_panel/reporting': typeof PanelReportingRoute
  '/_panel/': typeof PanelIndexRoute
  '/_panel/attachments/$attachmentId': typeof PanelAttachmentsAttachmentIdRoute
  '/_panel/queries/$queryId': typeof PanelQueriesQueryIdRoute
  '/_panel/vetting-requests/$vettingId': typeof PanelVettingRequestsVettingIdRoute
  '/_panel/vetting/$vettingId': typeof PanelVettingVettingIdRoute
  '/_panel/vetting/': typeof PanelVettingIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/experts'
    | '/reporting'
    | '/attachments/$attachmentId'
    | '/queries/$queryId'
    | '/vetting-requests/$vettingId'
    | '/vetting/$vettingId'
    | '/vetting/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/experts'
    | '/reporting'
    | '/'
    | '/attachments/$attachmentId'
    | '/queries/$queryId'
    | '/vetting-requests/$vettingId'
    | '/vetting/$vettingId'
    | '/vetting'
  id:
    | '__root__'
    | '/_panel'
    | '/login'
    | '/_panel/experts'
    | '/_panel/reporting'
    | '/_panel/'
    | '/_panel/attachments/$attachmentId'
    | '/_panel/queries/$queryId'
    | '/_panel/vetting-requests/$vettingId'
    | '/_panel/vetting/$vettingId'
    | '/_panel/vetting/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  PanelRoute: typeof PanelRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_panel': {
      id: '/_panel'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PanelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_panel/': {
      id: '/_panel/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PanelIndexRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/experts': {
      id: '/_panel/experts'
      path: '/experts'
      fullPath: '/experts'
      preLoaderRoute: typeof PanelExpertsRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/reporting': {
      id: '/_panel/reporting'
      path: '/reporting'
      fullPath: '/reporting'
      preLoaderRoute: typeof PanelReportingRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/attachments/$attachmentId': {
      id: '/_panel/attachments/$attachmentId'
      path: '/attachments/$attachmentId'
      fullPath: '/attachments/$attachmentId'
      preLoaderRoute: typeof PanelAttachmentsAttachmentIdRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/queries/$queryId': {
      id: '/_panel/queries/$queryId'
      path: '/queries/$queryId'
      fullPath: '/queries/$queryId'
      preLoaderRoute: typeof PanelQueriesQueryIdRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/vetting-requests/$vettingId': {
      id: '/_panel/vetting-requests/$vettingId'
      path: '/vetting-requests/$vettingId'
      fullPath: '/vetting-requests/$vettingId'
      preLoaderRoute: typeof PanelVettingRequestsVettingIdRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/vetting/': {
      id: '/_panel/vetting/'
      path: '/vetting'
      fullPath: '/vetting/'
      preLoaderRoute: typeof PanelVettingIndexRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/vetting/$vettingId': {
      id: '/_panel/vetting/$vettingId'
      path: '/vetting/$vettingId'
      fullPath: '/vetting/$vettingId'
      preLoaderRoute: typeof PanelVettingVettingIdRouteImport
      parentRoute: typeof PanelRoute
    }
  }
}

interface PanelRouteChildren {
  PanelExpertsRoute: typeof PanelExpertsRoute
  PanelReportingRoute: typeof PanelReportingRoute
  PanelIndexRoute: typeof PanelIndexRoute
  PanelAttachmentsAttachmentIdRoute: typeof PanelAttachmentsAttachmentIdRoute
  PanelQueriesQueryIdRoute: typeof PanelQueriesQueryIdRoute
  PanelVettingRequestsVettingIdRoute: typeof PanelVettingRequestsVettingIdRoute
  PanelVettingVettingIdRoute: typeof PanelVettingVettingIdRoute
  PanelVettingIndexRoute: typeof PanelVettingIndexRoute
}

const PanelRouteChildren: PanelRouteChildren = {
  PanelExpertsRoute: PanelExpertsRoute,
  PanelReportingRoute: PanelReportingRoute,
  PanelIndexRoute: PanelIndexRoute,
  PanelAttachmentsAttachmentIdRoute: PanelAttachmentsAttachmentIdRoute,
  PanelQueriesQueryIdRoute: PanelQueriesQueryIdRoute,
  PanelVettingRequestsVettingIdRoute: PanelVettingRequestsVettingIdRoute,
  PanelVettingVettingIdRoute: PanelVettingVettingIdRoute,
  PanelVettingIndexRoute: PanelVettingIndexRoute,
}

const PanelRouteWithChildren = PanelRoute._addFileChildren(PanelRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  PanelRoute: PanelRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
